import mixpanel from "mixpanel-browser";
import { ReadyToSendModalExperimentVariant } from "../../../../constants/ready-to-send-modal-experiment-variant.enum";
import {
  PENDING_READY_TO_SEND_ASSIGNMENT_STORAGE_KEY,
  READY_TO_SEND_EXPERIMENT_PROPERTY,
} from "./ready-to-send-experiment.const";

export function isReadyToSendAssignedVariant(
  variant: string | undefined
): variant is ReadyToSendModalExperimentVariant {
  return (
    variant === ReadyToSendModalExperimentVariant.CONTROL || variant === ReadyToSendModalExperimentVariant.SEND_MODAL
  );
}

export function assignReadyToSendExperiment(variant: string): void {
  if (!isReadyToSendAssignedVariant(variant)) {
    return;
  }

  if (mixpanel.has_opted_out_tracking()) {
    localStorage.setItem(PENDING_READY_TO_SEND_ASSIGNMENT_STORAGE_KEY, variant);
    return;
  }

  mixpanel.people.set_once({
    [READY_TO_SEND_EXPERIMENT_PROPERTY]: variant,
  });
  localStorage.removeItem(PENDING_READY_TO_SEND_ASSIGNMENT_STORAGE_KEY);
}

export function flushPendingReadyToSendAssignment(): void {
  const pendingVariant = localStorage.getItem(PENDING_READY_TO_SEND_ASSIGNMENT_STORAGE_KEY);
  if (!pendingVariant) {
    return;
  }

  assignReadyToSendExperiment(pendingVariant);
}
